import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to set the document title based on the current route.
 * Provides better accessibility for screen reader users navigating the site.
 * WCAG 2.2 Success Criterion 2.4.2 (Page Titled)
 */
const routeTitles: Record<string, string> = {
    '/': 'Home',
    '/login': 'Sign In',
    '/signups': 'Spring Signups',
    '/ladder': 'SSBU Ladder',
    '/trophies': 'Trophy Gallery',
    '/records': 'Player Records',
    '/games': 'Our Games',
    '/handbook': 'Handbook',
    '/conduct': 'Code of Conduct',
    '/schedule': 'Schedule',
    '/championships': 'Championships',
    '/parents': 'Parents Guide',
    '/app': 'Dashboard',
    '/app/player': 'Player Hub',
    '/app/techniques': 'Techniques',
    '/app/admin/events': 'Admin - Events',
    '/app/admin/teams': 'Admin - Teams',
    '/app/admin/ladder': 'Admin - SSBU Ladder',
    '/app/admin/vods': 'Admin - VoDs',
    '/app/admin/opponents': 'Admin - Opponents',
    '/app/admin/roster': 'Admin - Roster',
    '/app/admin/discord': 'Admin - Discord',
    '/app/admin/permission-slips': 'Admin - Permission Slips',
    '/app/admin/documents': 'Admin - Documents',
    '/app/admin/records': 'Admin - Records',
};

export function useDocumentTitle() {
    const location = useLocation();

    useEffect(() => {
        const baseTitle = 'Peck Pirates Esports';
        const pathTitle = routeTitles[location.pathname];

        if (pathTitle) {
            document.title = `${pathTitle} | ${baseTitle}`;
        } else if (location.pathname.startsWith('/parents/')) {
            // Dynamic parent guide pages
            document.title = `Parents Guide | ${baseTitle}`;
        } else if (location.pathname.startsWith('/app/player/')) {
            // Player profile pages
            document.title = `Player Profile | ${baseTitle}`;
        } else if (location.pathname.startsWith('/checkin/')) {
            // Check-in pages
            document.title = `Event Check-in | ${baseTitle}`;
        } else if (location.pathname.startsWith('/app/admin/events/')) {
            // Event detail pages
            document.title = `Event Details | ${baseTitle}`;
        } else {
            document.title = baseTitle;
        }
    }, [location.pathname]);
}
